import { Button, Distribute, Link, Spacer, Switch, Text } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import {
  ADD_PASSWORD_UPGRADE_BUTTON_CLICKED,
  SHARE_VIDEO_PRIVACY_UPDATED,
} from 'constants/events';
import { updateVideoSettings } from 'creators/shareVideo';
import { track } from 'utilities/analytics';

import { VIDEO_PASSWORD_PROTECT_ACTION } from '../../../../../../shared/constants/scopes';

import HideDuringDowntime from 'components/hide-during-downtime';
import Scopes from 'components/scopes';
import PrivateContent from 'components/share-video/share-video-widget/private-content';
import UpgradeTooltip from 'components/upgrade-tooltip';

import styles from './styles.module.less';

const PasswordUpgradeButton = () => (
  <UpgradeTooltip
    analyticsEvent={ADD_PASSWORD_UPGRADE_BUTTON_CLICKED}
    title="Password Protect Video"
  >
    <div className={styles.upgradeHover}>
      <Button hasFullWidth isDisabled variant="primary">
        Add Password
      </Button>
    </div>
    <Spacer bottom={1} />
  </UpgradeTooltip>
);

function PrivacySection({
  video,
  onCustomViewerClick,
  onAddPasswordClick,
  isFirstVideoShareModal = false,
}) {
  const dispatch = useDispatch();

  return (
    <HideDuringDowntime>
      <div>
        <div className="mb:medium">
          <PrivateContent
            onCustomViewerClick={onCustomViewerClick}
            isFirstVideoShareModal={isFirstVideoShareModal}
          />
        </div>
        <div className="mt:medium">
          <Scopes
            names={VIDEO_PASSWORD_PROTECT_ACTION}
            alternate={<PasswordUpgradeButton />}
          >
            <Distribute isSpread={true}>
              <>
                <Text fontWeight="medium" size="small">
                  Password protection.
                  {video.is_protected && (
                    <>
                      {` `}
                      <Link onClick={onAddPasswordClick}>Manage</Link>
                    </>
                  )}
                </Text>
              </>
              <Switch
                isActive={video.is_protected}
                onChange={e => {
                  const isChecked = e.target.checked;

                  if (isChecked) {
                    onAddPasswordClick();
                  } else {
                    track(SHARE_VIDEO_PRIVACY_UPDATED, {
                      action: 'removed',
                      video_id: video.id,
                    });
                    dispatch(updateVideoSettings({}, null));
                  }
                }}
              />
            </Distribute>
          </Scopes>
        </div>
      </div>
    </HideDuringDowntime>
  );
}

export default PrivacySection;
